import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function DoNotSellPage() {
  return (
    <div className="min-h-screen bg-[#060C18] text-white">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-24">
        <h1 data-testid="dns-title" className="text-4xl sm:text-5xl font-bold tracking-tight mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Do Not Sell My Personal Information
        </h1>
        <p className="text-white/40 mb-12">California Consumer Privacy Act (CCPA) Disclosure</p>

        <div className="space-y-10 text-white/70 leading-relaxed">
          <section className="bg-emerald-500/5 border border-emerald-500/20 rounded-2xl p-6">
            <h2 className="text-xl font-semibold text-emerald-400 mb-3">SendPI Does Not Sell Your Personal Information</h2>
            <p>SendPI has never sold, does not currently sell, and will not sell your personal information to third parties. This applies to all categories of personal information we collect.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">What this means</h2>
            <p>Under the California Consumer Privacy Act (CCPA), "sell" means sharing personal information with a third party for monetary or other valuable consideration. SendPI does not engage in this practice. We do not:</p>
            <ul className="list-disc ml-5 space-y-1 mt-3">
              <li>Sell your data to advertisers</li>
              <li>Share your data with data brokers</li>
              <li>Trade your data for any form of compensation</li>
              <li>Use your data for targeted advertising by third parties</li>
              <li>Share your communication patterns or PI scores with anyone</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Your CCPA rights</h2>
            <ul className="list-disc ml-5 space-y-2">
              <li><strong className="text-white">Right to Know:</strong> You can request a detailed report of all data we hold about you by using the "Export My Data" feature in Settings, or by emailing support@sendpi.ai.</li>
              <li><strong className="text-white">Right to Delete:</strong> You can permanently delete your account and all associated data from Settings at any time.</li>
              <li><strong className="text-white">Right to Non-Discrimination:</strong> We will never discriminate against you for exercising any of these rights.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Categories of information collected</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-white/10 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-white/5">
                    <th className="text-left p-3 text-white/60 border-b border-white/10">Category</th>
                    <th className="text-left p-3 text-white/60 border-b border-white/10">Collected</th>
                    <th className="text-left p-3 text-white/60 border-b border-white/10">Sold</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Identifiers (name, email)', 'Yes', 'No'],
                    ['Usage data (feature usage, PI scores)', 'Yes', 'No'],
                    ['Communication metadata (tone, intent)', 'Yes', 'No'],
                    ['Message content (your actual text)', 'No', 'No'],
                    ['Geolocation data', 'No', 'No'],
                    ['Financial information', 'No', 'No'],
                    ['Biometric information', 'No', 'No'],
                  ].map(([cat, collected, sold]) => (
                    <tr key={cat} className="border-b border-white/5">
                      <td className="p-3 text-white/70">{cat}</td>
                      <td className="p-3 text-white/70">{collected}</td>
                      <td className="p-3 text-emerald-400 font-medium">{sold}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Contact</h2>
            <p>For questions about this disclosure or to exercise your rights: <a href="mailto:support@sendpi.ai" className="text-cyan-400 hover:underline">support@sendpi.ai</a></p>
            <p className="mt-2 text-white/40 text-sm">We will verify your identity and respond within 45 days as required by the CCPA.</p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap gap-6">
          <Link to="/privacy" className="text-white/50 hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="text-white/50 hover:text-white transition-colors">Terms of Service</Link>
          <Link to="/" className="text-white/50 hover:text-white transition-colors">Back to Home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
